var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.69 56.69",
    style: {
      enableBackground: "new 0 0 56.69 56.69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#CE0E2D;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#CE0E2D;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M22.94,28.47c-0.57-0.7-1-1.54-1.2-2.48c-0.38-1.64-0.05-3.28,0.78-4.6c0.35-0.56,0.8-1.08,1.32-1.5l0.62,0.76 c-0.44,0.36-0.82,0.78-1.11,1.26c-0.69,1.1-0.96,2.48-0.65,3.86c0.18,0.79,0.53,1.49,1.02,2.09L22.94,28.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M32.84,20.05c0.69,0.59,1.25,1.34,1.63,2.23c0.65,1.54,0.62,3.22,0.03,4.66c-0.25,0.62-0.59,1.2-1.03,1.7 l-0.74-0.64c0.38-0.42,0.67-0.91,0.88-1.42c0.49-1.22,0.52-2.62-0.03-3.92c-0.33-0.75-0.79-1.38-1.38-1.88L32.84,20.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M21.21,29.86c-0.77-0.96-1.35-2.1-1.64-3.38c-0.51-2.23-0.07-4.47,1.06-6.27c0.48-0.77,1.1-1.46,1.8-2.04 l0.61,0.76c-0.62,0.5-1.16,1.12-1.59,1.8c-1,1.59-1.38,3.56-0.93,5.53c0.25,1.12,0.77,2.14,1.45,2.98L21.21,29.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M34.29,18.38c0.93,0.81,1.7,1.83,2.21,3.04c0.89,2.11,0.84,4.39,0.06,6.36l-0.01,0 c-0.33,0.84-0.82,1.63-1.42,2.32l-0.74-0.64c0.53-0.61,0.96-1.3,1.26-2.04c0.7-1.74,0.74-3.75-0.04-5.62 c-0.46-1.06-1.13-1.97-1.96-2.68L34.29,18.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M19.49,31.26c-0.98-1.21-1.71-2.66-2.08-4.28c-0.65-2.83-0.08-5.66,1.34-7.94h0.01 c0.62-0.97,1.38-1.85,2.29-2.58l0.62,0.76c-0.83,0.66-1.53,1.45-2.08,2.34c-1.3,2.07-1.81,4.64-1.23,7.2 c0.35,1.48,0.99,2.78,1.89,3.89L19.49,31.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M35.75,16.7c1.18,1.02,2.15,2.32,2.8,3.85c1.13,2.67,1.07,5.56,0.06,8.06c-0.44,1.06-1.03,2.06-1.8,2.94 l-0.73-0.63c0.68-0.8,1.24-1.7,1.62-2.67c0.92-2.26,0.98-4.88-0.05-7.31c-0.59-1.39-1.47-2.56-2.54-3.5L35.75,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M17.12,33.19c-1.27-1.57-2.2-3.44-2.69-5.53c-0.83-3.66-0.11-7.31,1.74-10.25c0.78-1.25,1.78-2.38,2.93-3.33 l0.62,0.76c-1.08,0.88-2,1.93-2.73,3.09c-1.72,2.73-2.38,6.12-1.61,9.51c0.44,1.95,1.32,3.68,2.49,5.14L17.12,33.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M37.74,14.4c1.52,1.32,2.77,2.99,3.61,4.96c1.46,3.45,1.38,7.17,0.08,10.39l-0.01,0 c-0.55,1.38-1.33,2.66-2.3,3.81l-0.75-0.65c0.91-1.06,1.64-2.25,2.16-3.52c1.21-2.98,1.27-6.44-0.08-9.64 c-0.78-1.84-1.94-3.39-3.36-4.61L37.74,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M29.8,24.74c0,0.75-0.61,1.36-1.36,1.36s-1.36-0.61-1.36-1.36s0.61-1.36,1.36-1.36S29.8,23.99,29.8,24.74"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M23.94,41.02h0.58l-0.18-0.47c-0.06-0.14-0.1-0.26-0.12-0.36c-0.02,0.11-0.05,0.22-0.09,0.33L23.94,41.02z  M23.45,41.72l0.65-1.7h0.24l0.7,1.7h-0.26l-0.2-0.51h-0.71l-0.19,0.51H23.45z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CE0E2D"
    },
    points: "25.22,41.72 25.22,40.02 25.44,40.02 25.44,41.52 26.28,41.52 26.28,41.72  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M26.86,41.02h0.58l-0.18-0.47c-0.05-0.14-0.09-0.26-0.12-0.36c-0.02,0.11-0.05,0.22-0.09,0.33L26.86,41.02z  M26.37,41.72l0.65-1.7h0.24l0.7,1.7H27.7l-0.2-0.51h-0.71l-0.18,0.51H26.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M28.37,40.77h0.49c0.1,0,0.18-0.01,0.24-0.03c0.06-0.02,0.1-0.06,0.13-0.1c0.03-0.05,0.05-0.1,0.05-0.15 c0-0.08-0.03-0.15-0.09-0.2c-0.06-0.05-0.15-0.08-0.28-0.08h-0.54V40.77z M28.14,41.72v-1.7h0.75c0.15,0,0.27,0.02,0.35,0.05 c0.08,0.03,0.14,0.08,0.19,0.16c0.04,0.08,0.07,0.16,0.07,0.26c0,0.12-0.04,0.22-0.12,0.3c-0.08,0.08-0.2,0.14-0.36,0.16 c0.06,0.03,0.1,0.06,0.14,0.09c0.07,0.06,0.13,0.13,0.19,0.22l0.3,0.46h-0.28l-0.23-0.35c-0.07-0.1-0.12-0.18-0.16-0.24 c-0.04-0.05-0.08-0.09-0.12-0.11l-0.1-0.04c-0.02-0.01-0.07-0.01-0.12-0.01h-0.26v0.76H28.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M29.85,41.72v-1.7h0.34l0.4,1.21c0.04,0.11,0.07,0.2,0.08,0.25c0.02-0.06,0.05-0.15,0.09-0.27l0.41-1.19h0.31 v1.7h-0.22V40.3l-0.49,1.42h-0.2l-0.49-1.45v1.45H29.85z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CE0E2D"
    },
    points: "31.85,41.72 31.85,40.02 33.08,40.02 33.08,40.22 32.07,40.22 32.07,40.74 33.02,40.74 33.02,40.94  32.07,40.94 32.07,41.52 33.12,41.52 33.12,41.72  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M22.16,37.61h0.58l-0.18-0.47c-0.05-0.14-0.09-0.26-0.12-0.35c-0.02,0.11-0.05,0.22-0.09,0.33L22.16,37.61z  M21.67,38.31l0.65-1.7h0.24l0.7,1.7h-0.26l-0.2-0.52h-0.71l-0.19,0.52H21.67z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CE0E2D"
    },
    points: "23.43,38.31 23.43,36.6 23.66,36.6 23.66,38.11 24.5,38.11 24.5,38.31  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M25.07,37.61h0.58l-0.18-0.47c-0.05-0.14-0.1-0.26-0.12-0.35c-0.02,0.11-0.05,0.22-0.09,0.33L25.07,37.61z  M24.58,38.31l0.65-1.7h0.24l0.7,1.7h-0.26l-0.2-0.52h-0.71l-0.19,0.52H24.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M26.59,37.35h0.49c0.1,0,0.18-0.01,0.24-0.03c0.06-0.02,0.1-0.05,0.13-0.1c0.03-0.05,0.04-0.1,0.04-0.15 c0-0.08-0.03-0.15-0.09-0.2c-0.06-0.05-0.15-0.08-0.28-0.08h-0.54V37.35z M26.36,38.31v-1.7h0.75c0.15,0,0.27,0.02,0.35,0.05 c0.08,0.03,0.14,0.08,0.19,0.16c0.05,0.08,0.07,0.16,0.07,0.26c0,0.12-0.04,0.22-0.12,0.31c-0.08,0.08-0.2,0.14-0.36,0.16 c0.06,0.03,0.1,0.06,0.14,0.08c0.07,0.06,0.13,0.14,0.19,0.23l0.29,0.46h-0.28l-0.22-0.35c-0.07-0.1-0.12-0.18-0.16-0.23 c-0.04-0.05-0.08-0.09-0.12-0.11l-0.1-0.05c-0.02-0.01-0.07-0.01-0.12-0.01h-0.26v0.76H26.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M28.07,38.31v-1.7h0.34l0.4,1.21c0.04,0.11,0.07,0.2,0.08,0.25c0.02-0.06,0.05-0.15,0.09-0.27l0.41-1.18h0.3 v1.7h-0.22v-1.43l-0.5,1.43h-0.2l-0.49-1.45v1.45H28.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M30.36,37.61h0.58l-0.18-0.47c-0.05-0.14-0.09-0.26-0.12-0.35c-0.02,0.11-0.05,0.22-0.09,0.33L30.36,37.61z  M29.87,38.31l0.65-1.7h0.24l0.7,1.7h-0.26l-0.2-0.52H30.3l-0.19,0.52H29.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M31.87,38.11h0.36c0.11,0,0.2-0.01,0.26-0.03c0.07-0.02,0.12-0.05,0.15-0.09c0.05-0.05,0.1-0.12,0.12-0.22 c0.03-0.09,0.05-0.2,0.05-0.33c0-0.18-0.03-0.32-0.09-0.41c-0.06-0.1-0.13-0.16-0.21-0.19c-0.06-0.02-0.16-0.04-0.29-0.04h-0.36 V38.11z M31.64,38.31v-1.7h0.59c0.13,0,0.23,0.01,0.31,0.02c0.1,0.02,0.18,0.07,0.25,0.12c0.09,0.08,0.16,0.17,0.2,0.29 c0.05,0.12,0.07,0.25,0.07,0.4c0,0.13-0.01,0.24-0.04,0.34c-0.03,0.1-0.07,0.18-0.12,0.25c-0.05,0.07-0.1,0.12-0.16,0.15 c-0.06,0.04-0.12,0.06-0.2,0.09c-0.08,0.02-0.17,0.03-0.27,0.03H31.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M33.53,37.48c0,0.2,0.05,0.37,0.17,0.48c0.11,0.12,0.25,0.18,0.42,0.18c0.17,0,0.31-0.06,0.42-0.18 c0.11-0.12,0.16-0.29,0.16-0.51c0-0.14-0.02-0.26-0.07-0.36c-0.05-0.1-0.11-0.19-0.21-0.24c-0.09-0.06-0.19-0.09-0.3-0.09 c-0.16,0-0.29,0.05-0.41,0.17C33.59,37.04,33.53,37.23,33.53,37.48 M33.3,37.48c0-0.28,0.08-0.5,0.23-0.66 c0.15-0.16,0.35-0.24,0.59-0.24c0.16,0,0.3,0.04,0.43,0.11c0.13,0.08,0.22,0.18,0.29,0.32c0.07,0.13,0.1,0.28,0.1,0.46 s-0.04,0.33-0.11,0.46c-0.07,0.14-0.17,0.24-0.3,0.31c-0.13,0.07-0.27,0.1-0.42,0.1c-0.16,0-0.3-0.04-0.43-0.11 c-0.13-0.08-0.22-0.18-0.29-0.32C33.33,37.77,33.3,37.63,33.3,37.48"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M19.54,34.2h0.58l-0.18-0.47c-0.05-0.14-0.1-0.26-0.12-0.35c-0.02,0.11-0.05,0.22-0.09,0.33L19.54,34.2z  M19.05,34.9l0.65-1.7h0.24l0.7,1.7h-0.26l-0.2-0.52h-0.71l-0.19,0.52H19.05z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CE0E2D"
    },
    points: "20.8,34.9 20.8,33.19 21.03,33.19 21.03,34.7 21.87,34.7 21.87,34.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M22.43,34.2h0.58l-0.18-0.47c-0.05-0.14-0.09-0.26-0.12-0.35c-0.02,0.11-0.05,0.22-0.09,0.33L22.43,34.2z  M21.94,34.9l0.65-1.7h0.24l0.7,1.7h-0.26l-0.2-0.52h-0.71l-0.19,0.52H21.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M23.93,33.94h0.49c0.1,0,0.18-0.01,0.24-0.03c0.06-0.02,0.1-0.06,0.13-0.1c0.03-0.05,0.05-0.1,0.05-0.15 c0-0.08-0.03-0.15-0.09-0.2c-0.06-0.05-0.15-0.08-0.28-0.08h-0.54V33.94z M23.71,34.9v-1.7h0.75c0.15,0,0.27,0.02,0.35,0.05 c0.08,0.03,0.14,0.08,0.19,0.16c0.05,0.08,0.07,0.16,0.07,0.26c0,0.12-0.04,0.22-0.12,0.31c-0.08,0.08-0.2,0.14-0.36,0.16 c0.06,0.03,0.1,0.06,0.14,0.09c0.07,0.06,0.13,0.14,0.18,0.23l0.3,0.46h-0.28l-0.22-0.35c-0.07-0.1-0.12-0.18-0.17-0.24 c-0.04-0.05-0.08-0.09-0.11-0.11l-0.1-0.04c-0.02-0.01-0.07-0.01-0.12-0.01h-0.26v0.76H23.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M25.41,34.9v-1.7h0.34l0.4,1.21c0.04,0.11,0.06,0.2,0.08,0.25c0.02-0.06,0.05-0.15,0.09-0.27l0.41-1.19h0.3 v1.7h-0.22v-1.43l-0.49,1.43h-0.2l-0.49-1.45v1.45H25.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M27.97,34.35l0.21-0.02c0.01,0.08,0.03,0.15,0.07,0.21c0.04,0.05,0.1,0.1,0.17,0.13 c0.08,0.03,0.17,0.05,0.26,0.05c0.09,0,0.16-0.01,0.23-0.04c0.07-0.03,0.12-0.06,0.15-0.1c0.03-0.05,0.05-0.1,0.05-0.15 c0-0.05-0.01-0.1-0.05-0.14c-0.03-0.04-0.08-0.08-0.15-0.1c-0.05-0.02-0.15-0.04-0.3-0.08c-0.16-0.04-0.27-0.07-0.33-0.11 c-0.08-0.04-0.14-0.1-0.18-0.16c-0.04-0.07-0.06-0.13-0.06-0.21c0-0.09,0.02-0.17,0.07-0.24c0.05-0.08,0.12-0.13,0.21-0.17 c0.1-0.04,0.2-0.06,0.32-0.06c0.12,0,0.23,0.02,0.33,0.06c0.1,0.04,0.17,0.1,0.22,0.18c0.05,0.08,0.08,0.17,0.08,0.27l-0.22,0.02 c-0.01-0.11-0.05-0.19-0.12-0.24c-0.07-0.05-0.16-0.08-0.3-0.08c-0.14,0-0.24,0.03-0.3,0.08c-0.06,0.05-0.1,0.11-0.1,0.18 c0,0.06,0.02,0.11,0.07,0.15c0.04,0.04,0.15,0.08,0.34,0.12c0.18,0.04,0.31,0.08,0.38,0.11c0.1,0.05,0.17,0.1,0.22,0.18 c0.05,0.07,0.07,0.15,0.07,0.24c0,0.09-0.03,0.18-0.08,0.26c-0.05,0.08-0.12,0.14-0.23,0.19c-0.1,0.04-0.2,0.06-0.33,0.06 c-0.15,0-0.28-0.02-0.39-0.07c-0.1-0.05-0.18-0.11-0.24-0.2C28,34.57,27.97,34.46,27.97,34.35"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M30.12,34.9v-0.72l-0.66-0.98h0.27l0.34,0.51c0.06,0.1,0.12,0.2,0.18,0.29c0.05-0.09,0.11-0.19,0.18-0.3 l0.33-0.5h0.26l-0.68,0.98v0.72H30.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M31.15,34.35l0.21-0.02c0.01,0.08,0.03,0.15,0.07,0.21c0.04,0.05,0.1,0.1,0.17,0.13 c0.08,0.03,0.17,0.05,0.26,0.05c0.09,0,0.16-0.01,0.23-0.04c0.07-0.03,0.11-0.06,0.15-0.1c0.03-0.05,0.05-0.1,0.05-0.15 c0-0.05-0.01-0.1-0.05-0.14c-0.03-0.04-0.08-0.08-0.15-0.1c-0.05-0.02-0.15-0.04-0.3-0.08c-0.16-0.04-0.27-0.07-0.33-0.11 c-0.08-0.04-0.14-0.1-0.18-0.16c-0.04-0.07-0.06-0.13-0.06-0.21c0-0.09,0.03-0.17,0.07-0.24c0.05-0.08,0.12-0.13,0.21-0.17 c0.09-0.04,0.2-0.06,0.31-0.06c0.13,0,0.24,0.02,0.33,0.06c0.09,0.04,0.17,0.1,0.22,0.18c0.05,0.08,0.08,0.17,0.08,0.27l-0.21,0.02 c-0.01-0.11-0.05-0.19-0.12-0.24c-0.07-0.05-0.17-0.08-0.3-0.08c-0.14,0-0.24,0.03-0.3,0.08c-0.06,0.05-0.09,0.11-0.09,0.18 c0,0.06,0.02,0.11,0.07,0.15c0.04,0.04,0.16,0.08,0.34,0.12c0.18,0.04,0.31,0.08,0.38,0.11c0.1,0.05,0.17,0.1,0.22,0.18 c0.05,0.07,0.07,0.15,0.07,0.24c0,0.09-0.02,0.18-0.08,0.26c-0.05,0.08-0.12,0.14-0.22,0.19c-0.1,0.04-0.21,0.06-0.33,0.06 c-0.15,0-0.28-0.02-0.39-0.07c-0.1-0.05-0.18-0.11-0.25-0.2C31.18,34.57,31.15,34.46,31.15,34.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CE0E2D"
    },
    points: "33.24,34.9 33.24,33.39 32.68,33.39 32.68,33.19 34.03,33.19 34.03,33.39 33.47,33.39 33.47,34.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CE0E2D"
    },
    points: "34.27,34.9 34.27,33.19 35.5,33.19 35.5,33.39 34.49,33.39 34.49,33.92 35.44,33.92 35.44,34.11  34.49,34.11 34.49,34.7 35.54,34.7 35.54,34.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE0E2D"
    },
    d: "M35.85,34.9v-1.7h0.34l0.4,1.21c0.04,0.11,0.06,0.2,0.08,0.25c0.02-0.06,0.05-0.15,0.09-0.27l0.41-1.19h0.3 v1.7h-0.22v-1.43l-0.5,1.43h-0.2l-0.49-1.45v1.45H35.85z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm1);
export default __webpack_public_path__ + "static/media/alarm (1).73f8cf543146969e098d5cd94cc9c660.svg";
export { ForwardRef as ReactComponent };